import {
  doctorPatientsApi,
  type DoctorPatientDetail,
  type DoctorPatientListItem,
} from '@shared/api/doctor-patients';
import type { GetPatientsParams } from '../types/patients.types';

export const getPatients = async (params: GetPatientsParams = {}): Promise<DoctorPatientListItem[]> => {
  const normalizedSearch = params.search?.trim();
  const response = await doctorPatientsApi.list({
    page: params.page ?? 1,
    limit: params.limit ?? 20,
    ...(normalizedSearch ? { search: normalizedSearch } : {}),
  });

  return response.data;
};

export const getPatientDetails = async (patientId: string): Promise<DoctorPatientDetail> => {
  const response = await doctorPatientsApi.detail(patientId);
  return response.data;
};

export const getUnreadPatientsCount = async (): Promise<number> => {
  const response = await doctorPatientsApi.unreadCount();
  return response.data.unreadCount;
};
